import {
  GET_NLT_DOCUMENTI_V1,
  GET_NLT_SERVIZI_PLUS_V1,
  GET_NLT_TABELLE_DOMINIO_CARICA_PRIVATA_V1,
  GET_NLT_TABELLE_DOMINIO_OCCUPAZIONE_V1,
  GET_NLT_TABELLE_DOMINIO_RUOLO_PA_V1,
  GET_NLT_TABELLE_DOMINIO_SETTORE_V1,
  GET_NLT_TABELLE_DOMINIO_SITUAZIONE_ABITATIVA_V1,
  GET_NLT_TABELLE_DOMINIO_SITUAZIONE_LAVORATIVA_V1,
  GET_NLT_TABELLE_DOMINIO_STATO_CIVILE_V1,
  GET_NLT_TABELLE_DOMINIO_TIPOLOGIA_CONTRATTO_V1,
  NLT_UPDATE_DATI,
  NLT_UPDATE_PAYMENT_METHOD,
  POST_CLIENTI_BRUMBRUM_V1,
  POST_NLT_DATI_CLIENTE_V1,
  POST_NLT_THANKYOU_V1,
  PUT_CLIENTI_BRUMBRUM_V1,
} from '../../constants/ActionTypes'
import {
  getNltService,
  isAutonomo,
  isConiugato,
  isDipendente,
  isNltBrumbrum,
  isRealLavoro,
  kycArvalApicale,
  puoNoleggiare,
  richiedeCaricaPrivata,
} from '../../utils/nltUtils'
import { createBasicCreator, fetchData } from '../Buy'

function getNltBaseUrl(product) {
  const nltService = getNltService(product)
  return `${window.brumbrum.url_api}/${nltService}/t/v1`
}

export const getNltServiziPlusV1 = (dispatch, getState) => {
  const idCanone = getState().nlt.selectedCanone.id_canone
  const idOrdine = getState().ordine.id_ordine
  const { product } = getState()
  const uri = `${getNltBaseUrl(
    product
  )}/canoni/${idCanone}/ordini/${idOrdine}/servizi`
  return dispatch(
    fetchData(GET_NLT_SERVIZI_PLUS_V1)({
      callback: GET_NLT_SERVIZI_PLUS_V1,
      errorMessage: GET_NLT_SERVIZI_PLUS_V1,
      method: 'GET',
      uri,
      suppressErrorNotice: true, // BRUM-9736 in caso di errori si skippa la schermata servizi plus
    })
  )
}

export const getNltTabelleDominioTipologiaContrattoV1 = (
  dispatch,
  getState
) => {
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/tabelle_dominio/tipologia_contratto`
  return dispatch(
    fetchData(GET_NLT_TABELLE_DOMINIO_TIPOLOGIA_CONTRATTO_V1)({
      callback: GET_NLT_TABELLE_DOMINIO_TIPOLOGIA_CONTRATTO_V1,
      errorMessage: GET_NLT_TABELLE_DOMINIO_TIPOLOGIA_CONTRATTO_V1,
      method: 'GET',
      uri,
    })
  )
}

export const getNltTabelleDominioStatoCivileV1 = (dispatch, getState) => {
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/tabelle_dominio/stato_civile`
  return dispatch(
    fetchData(GET_NLT_TABELLE_DOMINIO_STATO_CIVILE_V1)({
      callback: GET_NLT_TABELLE_DOMINIO_STATO_CIVILE_V1,
      errorMessage: GET_NLT_TABELLE_DOMINIO_STATO_CIVILE_V1,
      method: 'GET',
      uri,
    })
  )
}

export const getNltTabelleDominioSituazioneLavorativaV1 = (
  dispatch,
  getState
) => {
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/tabelle_dominio/situazione_lavorativa`
  return dispatch(
    fetchData(GET_NLT_TABELLE_DOMINIO_SITUAZIONE_LAVORATIVA_V1)({
      callback: GET_NLT_TABELLE_DOMINIO_SITUAZIONE_LAVORATIVA_V1,
      errorMessage: GET_NLT_TABELLE_DOMINIO_SITUAZIONE_LAVORATIVA_V1,
      method: 'GET',
      uri,
    })
  )
}

export const getNltTabelleDominioSituazioneAbitativaV1 = (
  dispatch,
  getState
) => {
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/tabelle_dominio/situazione_abitativa`
  return dispatch(
    fetchData(GET_NLT_TABELLE_DOMINIO_SITUAZIONE_ABITATIVA_V1)({
      callback: GET_NLT_TABELLE_DOMINIO_SITUAZIONE_ABITATIVA_V1,
      errorMessage: GET_NLT_TABELLE_DOMINIO_SITUAZIONE_ABITATIVA_V1,
      method: 'GET',
      uri,
    })
  )
}

export const getNltTabelleDominioOccupazioneV1 = (dispatch, getState) => {
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/tabelle_dominio/occupazione`
  return dispatch(
    fetchData(GET_NLT_TABELLE_DOMINIO_OCCUPAZIONE_V1)({
      callback: GET_NLT_TABELLE_DOMINIO_OCCUPAZIONE_V1,
      errorMessage: GET_NLT_TABELLE_DOMINIO_OCCUPAZIONE_V1,
      method: 'GET',
      uri,
    })
  )
}

export const getNltTabelleDominioCaricaPrivataV1 = (dispatch, getState) => {
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/tabelle_dominio/carica_privata`
  return dispatch(
    fetchData(GET_NLT_TABELLE_DOMINIO_CARICA_PRIVATA_V1)({
      callback: GET_NLT_TABELLE_DOMINIO_CARICA_PRIVATA_V1,
      errorMessage: GET_NLT_TABELLE_DOMINIO_CARICA_PRIVATA_V1,
      method: 'GET',
      uri,
    })
  )
}

export const getNltTabelleDominioSettoreV1 = (dispatch, getState) => {
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/tabelle_dominio/settore`
  return dispatch(
    fetchData(GET_NLT_TABELLE_DOMINIO_SETTORE_V1)({
      callback: GET_NLT_TABELLE_DOMINIO_SETTORE_V1,
      errorMessage: GET_NLT_TABELLE_DOMINIO_SETTORE_V1,
      method: 'GET',
      uri,
    })
  )
}

export const getNltTabelleDominioRuoloPaV1 = (dispatch, getState) => {
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/tabelle_dominio/ruolo_pa`
  return dispatch(
    fetchData(GET_NLT_TABELLE_DOMINIO_RUOLO_PA_V1)({
      callback: GET_NLT_TABELLE_DOMINIO_RUOLO_PA_V1,
      errorMessage: GET_NLT_TABELLE_DOMINIO_RUOLO_PA_V1,
      method: 'GET',
      uri,
    })
  )
}

export const nltUpdateDati = createBasicCreator(NLT_UPDATE_DATI)
export const nltUpdatePaymentMethod = createBasicCreator(
  NLT_UPDATE_PAYMENT_METHOD
)

export const postNltDatiClienteV1 = (dispatch, getState) => {
  const {
    nlt: { dati: nltDati },
    ordine,
    product,
    customer,
  } = getState()
  const payload = {
    anni_apertura_conto: nltDati.anni_apertura_conto,
    autocertificazione: nltDati.autocertificazione_1,
    consenso_base_privacy_arval: nltDati.consenso_base_privacy_arval,
    iban: nltDati.iban,
    presa_visione_condizioni_arval: nltDati.autocertificazione_2,
    situazione_abitativa: nltDati.situazione_abitativa,
    situazione_lavorativa: nltDati.situazione_lavorativa,
    stato_civile: nltDati.stato_civile,
  }

  if (nltDati.altre_fonti_switch === '1') {
    payload.altre_fonti_reddito = nltDati.altre_fonti_reddito
  }

  if (nltDati.carica_pubblica_switch === '1') {
    payload.carica_pubblica = nltDati.carica_pubblica
  }

  if (kycArvalApicale(nltDati)) {
    payload.dettaglio_ruolo_pa = nltDati.dettaglio_ruolo_pa
  }

  if (isAutonomo(nltDati.situazione_lavorativa)) {
    // In caso di Autonomo/Libero professionista
    payload.settore = nltDati.settore
    payload.professione = nltDati.professione
  }

  if (
    richiedeCaricaPrivata(nltDati.situazione_lavorativa, nltDati.occupazione)
  ) {
    payload.carica_privata = nltDati.carica_privata || ''
  }

  if (isConiugato(nltDati.stato_civile)) {
    payload.reddito_coniuge = nltDati.reddito_coniuge || '0'
  }

  if (isRealLavoro(nltDati.situazione_lavorativa, nltDati.tipo_contratto)) {
    payload.societa = nltDati.nome_societa || ''
    payload.anzianita_lavoro = nltDati.anzianita || ''
  }

  if (puoNoleggiare(nltDati.situazione_lavorativa, nltDati.tipo_contratto)) {
    payload.reddito = nltDati.reddito_mensile || ''
  }

  if (isDipendente(nltDati.situazione_lavorativa)) {
    payload.tipologia_contratto = nltDati.tipo_contratto || ''
    payload.occupazione = nltDati.occupazione || ''
  }

  const idOrdine = ordine.id_ordine
  /**
   * su nlt arval i dati cliente sono dentro nlt
   * su nlt brumbrum i dati cliente sono dentro clienti
   */
  const clientiPath = isNltBrumbrum(product)
    ? `/clienti/t/v1/nlt_brumbrum`
    : `/nlt/t/v1/clienti/${idOrdine}`
  const uri = `${window.brumbrum.url_api}${clientiPath}`

  if (isNltBrumbrum(product)) {
    const { id_cliente_brumbrum } = customer
    const postClientiBrumbrum = fetchData(POST_CLIENTI_BRUMBRUM_V1)({
      body: JSON.stringify({ id_ordine: ordine.id_ordine }),
      callback: POST_CLIENTI_BRUMBRUM_V1,
      errorMessage: POST_CLIENTI_BRUMBRUM_V1,
      method: 'POST',
      uri,
    })

    const noPostClientiBrumbrum = () =>
      new Promise(resolve => {
        resolve({
          result: {
            id_cliente: id_cliente_brumbrum,
          },
        })
      })

    const dispatchThis = id_cliente_brumbrum
      ? noPostClientiBrumbrum
      : postClientiBrumbrum

    const payloadClientiKeys = [
      'societa',
      'anzianita_lavoro',
      'altre_fonti_reddito',
      'carica_pubblica',
      'dettaglio_ruolo_pa',
      'anni_apertura_conto',
      'iban',
      'presa_visione_condizioni_brumbrum',
      'consenso_base_privacy_brumbrum',
      'autocertificazione',
      'situazione_abitativa',
      'situazione_lavorativa',
      'occupazione',
      'reddito',
      'reddito_coniuge',
      'carica_privata',
      'tipologia_contratto',
      'stato_civile',
      'professione',
      'indirizzo_lavoro',
      'civico_lavoro',
      'cap_lavoro',
      'comune_lavoro',
      'provincia_lavoro',
      'cf_lavoro',
      'reddito_mensile_netto_verificato',
      'reddito_annuo_lordo_verificato',
      // 'relazione_intestatario_iban',
    ]

    const payloadClientiBrumbrum = payloadClientiKeys.reduce(
      (acc, clientiKey) => {
        // aggiungo solo le chiavi richieste
        // da api clienti brumbrum
        if (nltDati[clientiKey]) {
          acc[clientiKey] = nltDati[clientiKey]
        }

        // senza else perche' alcune vengono
        // trasformate
        // il valore in payload ha la precedenza
        if (payload[clientiKey]) {
          acc[clientiKey] = payload[clientiKey]
        }

        if (
          acc[clientiKey] &&
          (acc[clientiKey] === '1' || acc[clientiKey] === '0')
        ) {
          // il nuovo clienti vuole numeri!
          acc[clientiKey] = parseInt(acc[clientiKey])
        }

        return acc
      },
      {}
    )

    /**
     * prima fa la POST a clienti per creare id_cliente
     * poi fa la PUT a clienti per inserire tutti i dati
     * risolve la promise con i response payload mergiati
     * di entrambe le chiamate
     */
    return new Promise((resolve, reject) => {
      dispatch(dispatchThis)
        .then(json => {
          dispatch(
            fetchData(PUT_CLIENTI_BRUMBRUM_V1)({
              body: JSON.stringify(payloadClientiBrumbrum),
              callback: PUT_CLIENTI_BRUMBRUM_V1,
              errorMessage: PUT_CLIENTI_BRUMBRUM_V1,
              method: 'PUT',
              uri: `${uri}/${json.result.id_cliente}`,
            })
          )
            .then(_json => {
              resolve({ ...json, ..._json })
            })
            .catch(ex => reject(ex))
        })
        .catch(ex => reject(ex))
    })
  }
  return dispatch(
    fetchData(POST_NLT_DATI_CLIENTE_V1)({
      body: JSON.stringify(payload),
      callback: POST_NLT_DATI_CLIENTE_V1,
      errorMessage: POST_NLT_DATI_CLIENTE_V1,
      method: 'POST',
      uri,
    })
  )
}

export const getNltDocumentiV1 = (dispatch, getState) => {
  const idOrdine = getState().ordine.id_ordine
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/documenti/${idOrdine}`
  return dispatch(
    fetchData(GET_NLT_DOCUMENTI_V1)({
      callback: GET_NLT_DOCUMENTI_V1,
      errorMessage: GET_NLT_DOCUMENTI_V1,
      method: 'GET',
      uri,
    })
  )
}

export const postNltThankYouV1 = (dispatch, getState) => {
  const idOrdine = getState().ordine.id_ordine
  const { product } = getState()
  const uri = `${getNltBaseUrl(product)}/thank-you/${idOrdine}`
  return dispatch(
    fetchData(POST_NLT_THANKYOU_V1)({
      callback: POST_NLT_THANKYOU_V1,
      errorMessage: POST_NLT_THANKYOU_V1,
      method: 'POST',
      uri,
    })
  )
}
